import { REVEAL_METERS } from 'features/customers/constants/apiMeters'

import type { RevealQuotaDimension } from '@albacross/types'

import { validateDomainAllowlist } from './domain-allowlist'

const LIMIT_FIELDS: Record<RevealQuotaDimension, string> = {
  requests: 'revealApiRequestsLimit',
  identified: 'revealApiIdentifiedLimit',
  uniqueIdentifiedIps: 'revealApiUniqueIdentifiedIpsLimit',
}

const limitErrors = (values: Record<string, unknown>) =>
  Object.fromEntries(
    (Object.keys(LIMIT_FIELDS) as RevealQuotaDimension[])
      .filter(dimension => !values[LIMIT_FIELDS[dimension]])
      .map(dimension => [LIMIT_FIELDS[dimension], `${REVEAL_METERS[dimension].label} limit is required`]),
  )

export const generateRevealApiKeyValidator = values => {
  const errors: Record<string, any> = limitErrors(values)

  if (!values.publicApiKeyDomainAllowlist) {
    errors.publicApiKeyDomainAllowlist = 'Domain allowlist is required'
  } else {
    const domainError = validateDomainAllowlist(values.publicApiKeyDomainAllowlist)
    if (domainError) errors.publicApiKeyDomainAllowlist = domainError
  }

  return errors
}

export const modifyRevealApiLimitsValidator = values => {
  const errors: Record<string, any> = limitErrors(values)

  const domainError = validateDomainAllowlist(values.publicApiKeyDomainAllowlist)
  if (domainError) errors.publicApiKeyDomainAllowlist = domainError

  return errors
}
